import React from 'react'

import { CircularProgress, InputAdornment, makeStyles, P, TextField, theme, useWatch } from '@guiker/react-framework'

import { useTranslation } from '../../hooks'

const useStyles = makeStyles({
  verify: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
})

type VerifyEmailTextFieldProps = {
  prefix?: string
  defaultValue: string
  verifyEmail: (emailAddress: string) => void
  clearUserData: () => void
  isLoading: boolean
  readOnly?: boolean
  emailName?: string
}

export const VerifyEmailTextField: React.FC<VerifyEmailTextFieldProps> = ({
  prefix,
  defaultValue,
  verifyEmail,
  clearUserData,
  isLoading,
  readOnly = false,
  emailName: emailAdressName = 'emailAddress',
}) => {
  const { t } = useTranslation(['common', 'office-payment'])
  const classes = useStyles()
  const name = prefix ? `${prefix}.${emailAdressName}` : emailAdressName

  const id = useWatch({ name: prefix ? `${prefix}.id` : 'id' })
  const firstName = useWatch({ name: prefix ? `${prefix}.firstName` : 'firstName' })
  const emailAddress = useWatch({ name, defaultValue })

  const onClick = () => {
    if (!isLoading) {
      !!id || !!firstName ? clearUserData() : verifyEmail(emailAddress)
    }
  }

  return (
    <TextField
      required
      name={name}
      type='email'
      label={t('common:user.emailAddress')}
      readOnly={readOnly}
      defaultValue={emailAddress}
      onChange={(e) => {
        e.target.value === '' && clearUserData()
      }}
      onKeyDown={(e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !!emailAddress) {
          e.preventDefault()
          e.stopPropagation()
          verifyEmail(emailAddress)
        }
      }}
      endAdornment={
        !readOnly && (
          <InputAdornment className={classes.verify} position='end' onClick={onClick}>
            {isLoading ? (
              <CircularProgress size={16} color='primary' />
            ) : (
              <P component='span' className={classes.verify}>
                {t(`office-payment:customCharge.actions.${!!id || !!firstName ? 'clear' : 'verify'}`)}
              </P>
            )}
          </InputAdornment>
        )
      }
    />
  )
}
